import * as React from 'react';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import { Typography, Box, Button, Grid, ButtonProps, Alert, Stack, Divider, LinearProgress } from '@mui/material';
import Common from '../utilities/common';
import $ from "jquery";
import { DataGrid, GridColumnHeaderParams, GridCsvExportOptions, GridCsvGetRowsToExportParams, gridExpandedSortedRowIdsSelector, GridToolbarContainer, useGridApiContext } from '@mui/x-data-grid';
import Layout from '../components/Utilities/Layout';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import EntitySettings from '../components/EntitySettings';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import SignpostOutlinedIcon from '@mui/icons-material/SignpostOutlined';
import TrafficOutlinedIcon from '@mui/icons-material/TrafficOutlined';
import MarkunreadMailboxOutlinedIcon from '@mui/icons-material/MarkunreadMailboxOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import HolidayVillageOutlinedIcon from '@mui/icons-material/HolidayVillageOutlined';
import LocationCityOutlinedIcon from '@mui/icons-material/LocationCityOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import LightOutlinedIcon from '@mui/icons-material/LightOutlined';
import LocalFireDepartmentOutlinedIcon from '@mui/icons-material/LocalFireDepartmentOutlined';
import Man2OutlinedIcon from '@mui/icons-material/Man2Outlined';
import Woman2OutlinedIcon from '@mui/icons-material/Woman2Outlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import WcIcon from '@mui/icons-material/Wc';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';
import ReactInterval from 'react-interval';

let fileName: string = 'extraccion_cliente_';

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const CustomToolbar = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
      <GridToolbarContainer>
        <Button
          {...buttonBaseProps}
          onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: fileName })}
        >
          Exportar CSV
        </Button>
      </GridToolbarContainer>
    );
}

export interface IDetalleExtraccionState {
    data: any[];
    extraccion: any;
}

export default class DetalleExtraccion extends React.Component<{}, IDetalleExtraccionState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            extraccion: null
        };
    }

    componentDidMount(): void {
        this.GetExtraccion();
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <SecurityTrimmer entity={Entity.Extracciones} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                <ReactInterval timeout={3000} enabled={this.state.extraccion != null && this.state.extraccion.status != 'Finalizado' && this.state.extraccion.status != 'Error'} callback={() => {
                    this.Get();
                    this.GetExtraccion();
                }}/>
                <Layout breadcrumb={
                    [
                        {
                            title: 'Inicio',
                            url: '/'
                        },
                        {
                            title: 'Extracciones',
                            url: '/extracciones'
                        },
                        {
                            title: 'Detalle',
                            url: ''
                        }
                    ]
                }>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <ExitToAppOutlinedIcon className='mainIcon'/>
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography className='mainTitle'>
                                Detalle de extracción
                                </Typography>
                            </Grid>
                            <Grid item xs={2} className='entitySettings'>
                                <EntitySettings entity={Entity.Extracciones}/>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className='main'>
                        <Stack direction={'row'} justifyContent={'space-between'}>
                            <Typography variant='h6' fontWeight={300}>
                            {
                                this.state.extraccion != null && (
                                    this.state.extraccion.razonSocial
                                )
                            }
                            </Typography>
                            {
                                this.state.extraccion != null && (
                                    <React.Fragment>
                                        {
                                            Common.RenderIconStatus(this.state.extraccion, 'status')
                                        }
                                    </React.Fragment>
                                )
                            }
                        </Stack>
                        <Divider style={{marginBottom: '20px'}}/>
                        {
                            this.state.extraccion != null && this.state.extraccion.date != null && (
                                <Stack direction="row" spacing={1} style={{marginBottom: '10px'}}>
                                    <CalendarMonthOutlinedIcon titleAccess='Fecha de solicitud'/>
                                    <Typography variant='body2' style={{position: 'relative', top: '5px', marginRight: '10px'}}>
                                    {
                                        `${new Date(this.state.extraccion.date).toLocaleDateString()} ${new Date(this.state.extraccion.date).toLocaleTimeString()}`
                                    }
                                    </Typography>
                                </Stack>
                            )
                        }
                        {
                            this.state.extraccion != null && this.state.extraccion.startTime.indexOf != undefined && (
                                <Stack direction="row" spacing={1} style={{marginBottom: '10px'}}>
                                    <PlayCircleOutlineOutlinedIcon titleAccess='Hora de inicio'/>
                                    <Typography variant='body2' style={{position: 'relative', top: '5px', marginRight: '10px'}}>
                                    {
                                        `${new Date(this.state.extraccion.startTime).toLocaleDateString()} ${new Date(this.state.extraccion.startTime).toLocaleTimeString()}`
                                    }
                                    </Typography>
                                </Stack>
                            )
                        }
                        {
                            this.state.extraccion != null && this.state.extraccion.endTime.indexOf != undefined && (
                                <Stack direction="row" spacing={1} style={{marginBottom: '10px'}}>
                                    <StopCircleOutlinedIcon titleAccess='Hora de finalización'/>
                                    <Typography variant='body2' style={{position: 'relative', top: '5px'}}>
                                    {
                                        `${new Date(this.state.extraccion.endTime).toLocaleDateString()} ${new Date(this.state.extraccion.endTime).toLocaleTimeString()}`
                                    }
                                    </Typography>
                                </Stack>
                            )
                        }
                        {
                            this.state.extraccion != null && this.state.extraccion.status == 'En proceso' && (
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box sx={{ width: '100%', mr: 1 }}>
                                        <LinearProgress variant="determinate" value={this.state.extraccion.progress} />
                                    </Box>
                                    <Box sx={{ minWidth: 35 }}>
                                        <Typography variant="body2" color="text.secondary">
                                            {
                                                `${this.state.extraccion.progress}%`
                                            }
                                        </Typography>
                                    </Box>
                                </Box>
                            )
                        }
                    </Box>
                    <Box className='main'>
                        {
                            this.state.extraccion != null && this.state.extraccion.status == 'Pendiente' && (
                                <Alert severity='info'>
                                    Esperando que se inicie el proceso de extracción
                                </Alert>
                            )
                        }
                        {
                            this.state.extraccion != null && this.state.extraccion.status != 'Pendiente' && (
                                <DataGrid
                                    slots={{ toolbar: CustomToolbar }}
                                    autoHeight
                                    rows={this.state.data}
                                    slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                                    columns={[
                                        { 
                                            field: 'nombre', 
                                            headerName: 'Nombre', 
                                            width: 250,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'nombre')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'apellidos', 
                                            headerName: 'Apellidos', 
                                            width: 250,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'apellidos')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'telefono', 
                                            headerName: 'Telefono', 
                                            width: 150,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'telefono')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'tipoVia', 
                                            headerName: 'Tipo de vía', 
                                            width: 150,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'tipoVia')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'nombreVia', 
                                            headerName: 'Nombre de la vía', 
                                            width: 250,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'nombreVia')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'numeroVia', 
                                            headerName: 'Número', 
                                            width: 100,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'numeroVia')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'restoDireccion', 
                                            headerName: 'Resto dirección', 
                                            width: 250,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'restoDireccion')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'cp', 
                                            headerName: 'CP', 
                                            width: 250,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'cp')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'municipio', 
                                            headerName: 'Municipio', 
                                            width: 250,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'municipio')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'provincia', 
                                            headerName: 'Provincia', 
                                            width: 250,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'provincia')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'fechaNacimiento', 
                                            headerName: 'Fecha de nacimiento', 
                                            width: 200,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'fechaNacimiento')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'email', 
                                            headerName: 'Email', 
                                            width: 250,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'email')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'sexo', 
                                            headerName: 'Sexo', 
                                            width: 100,
                                            renderCell: ({ row }) => (
                                                <div>
                                                    {
                                                        row.sexo?.toLowerCase() == 'h' && (
                                                            <Man2OutlinedIcon style={{fontSize: '20px', position: 'relative', top: '6px'}}/>
                                                        )
                                                    }
                                                    {
                                                        row.sexo?.toLowerCase() == 'm' && (
                                                            <Woman2OutlinedIcon style={{fontSize: '20px', position: 'relative', top: '6px'}}/>
                                                        )
                                                    }
                                                </div>
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'operador', 
                                            headerName: 'Operador', 
                                            width: 250,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'operador')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'cupsLuz', 
                                            headerName: 'Cups Luz', 
                                            width: 250,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'cupsLuz')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'cupsGas', 
                                            headerName: 'Cups Gas', 
                                            width: 250,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'cupsGas')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'url', 
                                            headerName: 'URL', 
                                            width: 250,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'url')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        },
                                        { 
                                            field: 'ip', 
                                            headerName: 'IP', 
                                            width: 250,
                                            renderCell: ({ row }) => (
                                                this.RenderCell(row, 'ip')
                                            ),
                                            renderHeader: this.RenderHeader.bind(this)
                                        }
                                    ]}
                                    initialState={{
                                        pagination: {
                                            paginationModel: { page: 0, pageSize: 30 },
                                        },
                                    }}
                                    pageSizeOptions={[30, 60, 100, 250, 300]}
                                    hideFooter={this.state.data.length <= 30}
                                />
                            )
                        }
                </Box>
                </Layout>
            </SecurityTrimmer>
        )
    }

    private Get() {
        const id = Common.getUrlParam('id');
        let url = `${Common.END_POINT}/extracciones/data/${id}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState({
                data: response
            })
        })
    }

    private GetExtraccion() {
        const id = Common.getUrlParam('id');
        let url = `${Common.END_POINT}/extracciones/detail/${id}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            fileName = `${response[0].razonSocial}_export_${response[0].date.replaceAll('-', '_')}`;

            this.setState({
                extraccion: response[0]
            })
        })
    }

    private RenderCell(row: any, key: string): JSX.Element {
        let hasErrors: boolean = (row[key] == null || row[key] == '' || row[key].indexOf == undefined);

        return (
            <div style={{textAlign: key == 'cp' || key == 'numeroVia' || key == 'telefono' ? 'center' : 'left'}}>
                {/*
                    hasErrors && (
                        <Alert severity="error"></Alert>
                    )
                */}
                {
                    !hasErrors && row[key].indexOf != undefined && (
                        row[key]
                    )
                }
            </div>
        )
    }

    private RenderHeader(params: GridColumnHeaderParams): JSX.Element {
        return (
            <React.Fragment>
                {
                    (params.colDef.field == "nombre" || params.colDef.field == "apellidos") && (
                        <BadgeOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "sexo" && (
                        <WcIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "fechaNacimiento" && (
                        <CakeOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "telefono" && (
                        <LocalPhoneOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "tipoVia" && (
                        <TrafficOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "nombreVia" && (
                        <SignpostOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "numeroVia" && (
                        <ConfirmationNumberOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "restoDireccion" && (
                        <BusinessOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "municipio" && (
                        <HolidayVillageOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "provincia" && (
                        <LocationCityOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "cp" && (
                        <MarkunreadMailboxOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "email" && (
                        <AlternateEmailOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "cupsLuz" && (
                        <LightOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                {
                    params.colDef.field == "cupsGas" && (
                        <LocalFireDepartmentOutlinedIcon style={{
                            fontSize: '20px',
                            position: 'relative',
                            top: '-2px'
                        }}/>
                    )
                }
                <strong style={{display: 'inline-block', marginLeft: '5px'}}>
                {
                    params.colDef.headerName
                }
                </strong>
            </React.Fragment>
        )
    }
}